import { decodeToken } from '../../session/decode';

/** Refresh access token this long before JWT `exp` (while tab is visible). */
export const TOKEN_REFRESH_BUFFER_MS = 5 * 60 * 1000;

/**
 * Largest delay `setTimeout` can hold (signed 32-bit int, ~24.8 days). Delays
 * above this overflow and fire almost immediately, so any scheduled refresh must
 * be clamped to it — otherwise a far-future `exp` turns into an infinite refresh loop.
 */
export const MAX_TIMEOUT_MS = 2147483647;

/**
 * Milliseconds until a proactive refresh should run (exp minus buffer).
 * Returns 0 if already inside the buffer or past expiry. Null if token has no exp.
 */
export const getMillisecondsUntilRefresh = (
  accessToken: string | null,
  bufferMs: number = TOKEN_REFRESH_BUFFER_MS,
  nowMs: number = Date.now()
): number | null => {
  const decoded = decodeToken(accessToken);

  if (!decoded?.exp) {
    return null;
  }

  const refreshAtMs = decoded.exp * 1000 - bufferMs;

  return Math.max(0, refreshAtMs - nowMs);
};
